/**
 * @ngdoc object
 * @name users
 * @description
 *
 */
angular
    .module('festzelt-os.seatplans', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./seatplans-routes');

// Controllers
require('./controllers/seatplans-create-controller');
require('./controllers/seatplans-demo-controller');
require('./controllers/seatplans-details-controller');
require('./controllers/seatplans-edit-controller');
require('./controllers/seatplans-elements-controller');

// Directives
require('./directives/seatplan-example-directive');
require('./directives/seatplan-group-directive');


// Factories
require('./factories/seatplan-element-factory');
require('./factories/seatplan-factory');
require('./factories/seatplan-group-factory');
require('./factories/rse-factory');
require('./factories/seatplan-area-factory');

// Stores
require('./store/seatplans');
require('./store/seatplan_elements');
require('./store/areas');
require('./store/rse');

// Scripts

// Workflows
require('./workflows/archive-seatplan');
require('./workflows/create-seatplan');
require('./workflows/delete-seatplan');
require('./workflows/edit-seatplan');
require('./workflows/restore-seatplan');
require('./workflows/view-seatplan');



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/seatplans-module.js